import { useEffect, useState } from 'react'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

import './style.scss';
import { INSTRUCTOR_GENDERS } from '../../constants/searchConstants';
import { getCroppedImg, getRotatedImage, readFile } from '../../utils/Cropper';
import { Orientation, getOrientation } from 'get-orientation';
import { ImageUploadResponse } from '../../server/types';
import { getApiUrl } from '../../constants/pathConstants';
import Cropper from 'react-easy-crop';
import CtaButton from '../../components/ctaButton/CtaButton';
import { updateConnector } from '../../server/connector/updateConnector';
import { useCookies } from 'react-cookie';

function AppProfileSettings() {

	const [valuesUpdated, setValuesUpdated] = useState<boolean>(false)
	const [heroImgSrc, setHeroImgSrc] = useState<string | undefined>(userStateData.getUserHeroUrl()) // useState<string>('')

	const [cookies, setCookie] = useCookies(['userData'])

	const [crop, setCrop] = useState({ x: 0, y: 0 })
	const [rotation, setRotation] = useState(0)
	const [zoom, setZoom] = useState(1)
	const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null)
	const [imageSrc, setImageSrc] = useState<any>(null)
	const [uploadingImage, setUploadingImage] = useState<boolean>(false)

	const [uploadingProfilePic, setUploadingProfilePic] = useState<boolean>(false)

	const [userProfileIconUrl, setUserProfileIconUrl] = useState<string | undefined>(userStateData.getUserIconUrl())

	const [usersName, setUsersName] = useState<string>('')
	const [bioText, setBioText] = useState<string>('')
	const [userIsVerified, setUserIsVerified] = useState<boolean>(true)

	const [updatingUserData, setUpdatingUserData] = useState<boolean>(false)

	const [dobDate, setDobDate] = useState<string | undefined>('')
	const [dobMonth, setDobMonth] = useState<string | undefined>('')
	const [dobYear, setDobYear] = useState<number | undefined>(undefined)
	const [gender, setGender] = useState<string>(userStateData.getGender() || '')
	const genderSelectHandler = (newValue: string) => {
		userStateData.setGender(newValue)
		setGender(newValue)
	}
	const [links, setLinks] = useState<string>('')

	const onFileChange = async (e: any) => {
		if (e.target.files && e.target.files.length > 0) {
			const file = e.target.files[0]
			let imageDataUrl = await readFile(file)

			try {
				// apply rotation if needed
				const orientation = await getOrientation(file)
				let rotation: number = 0 // ORIENTATION_TO_ANGLE[orientation]
				if (orientation == Orientation.BOTTOM_RIGHT) {
					rotation = 180
				} else if (orientation == Orientation.RIGHT_TOP) {
					rotation = 90
				} else if (orientation == Orientation.LEFT_BOTTOM) {
					rotation = -90
				}
				imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
			} catch (e) {
				console.warn('failed to detect the orientation')
			}

			setImageSrc(imageDataUrl)
		}
	}
	const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
		setCroppedAreaPixels(croppedAreaPixels)
	}
	const showCroppedImage = async () => {
		try {
			const croppedImage = await getCroppedImg(
				imageSrc,
				croppedAreaPixels,
				rotation,
				{ horizontal: false, vertical: false },
				512,
				uploadingProfilePic ? 512 : 205
			)
			uploadImage(croppedImage, uploadingProfilePic)
			setImageSrc(null)
		} catch (e) {
			console.error(e)
		}
	}
	const uploadImage = (file: File, isProfilePic: boolean) => {
		setUploadingImage(true)
		const API_ENDPOINT = `${getApiUrl()}${isProfilePic ? 'upload-image' : 'upload-hero-image'}`
		const request = new XMLHttpRequest()
		const formData = new FormData()

		request.open("POST", API_ENDPOINT, true)
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				const responseObj: ImageUploadResponse = JSON.parse(request.responseText)
				if (responseObj.error) {
					setUploadingImage(false)
				} else if (responseObj.fileName) {
					if (isProfilePic) {
						profileImageAdded(responseObj.fileName)
					} else {
						heroImageAdded(responseObj.fileName)
					}
				}
			}
		}
		formData.append("file", file);
		request.send(formData);
	}
	const heroImageAdded = (fileName: string) => {
		setUploadingImage(false)
		setUpdatingUserData(true)
		setValuesUpdated(true)
		if (updateConnector.requestInProgress) {
			console.log('[AppProfileSettings] - heroImageAdded() called while requestInProgress')
		} else {
			// updateConnector.updateInstructorHeroPicRequest(userStateData.getId(), fileName).then((successRequest) => {
			updateConnector.updateUserHeroPicRequest(userStateData.getId(), fileName).then((successRequest) => {
				setUpdatingUserData(false)
				if (!successRequest) {
					console.log('WARNING - [AppProfileSettings] - heroImageAdded() failed')
				} else {
					userStateData.setHeroPic(fileName)
					setHeroImgSrc(userStateData.getUserHeroUrl())
					updateCookies()
				}
			}).finally(() => {
				// checkMinimumRequirements()
			})
		}
	}
	const profileImageAdded = (fileName: string) => {
		setUploadingImage(false)
		// // Called when new image upload is complete so image details can be updated
		setUpdatingUserData(true)
		setValuesUpdated(true)
		// reform image string
		let splitPics: string[] = userStateData.getSplitProfilePics()
		if (splitPics[0]) {
			splitPics[0] = fileName
		}
		const newString: string = splitPics.join(',')

		if (updateConnector.requestInProgress) {
			console.log('[AppProfileSettings] - imageAdded() called while requestInProgress')
		} else {
			// updateConnector.updateInstructorProfilePicsRequest(userStateData.getId(), newString).then((successRequest) => {
			updateConnector.updateUserProfilePicsRequest(userStateData.getId(), newString).then((successRequest) => {
				setUpdatingUserData(false)
				if (!successRequest) {
					console.log('WARNING - [AppProfileSettings] - imageAdded() failed')
				} else {
					userStateData.setProfilePics(newString)
					// updateUserValues()
					// setProfilePicUrls(userStateData.getSplitProfilePics())
					setUserProfileIconUrl(userStateData.getUserIconUrl())
					updateCookies()
					// window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
				}
			}).finally(() => {
				// checkMinimumRequirements()
			})
		}
	}

	const updateCookies = () => {
		setCookie("userData", userStateData.getUserData(), {
			path: "/"
		})
	}

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn === false) {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		} else {
			getProfileData()
		}
	}, [])

	const getProfileData = () => {
		setUsersName(userStateData.getUsersName())
		const bioStr: string = userStateData.getAboutText() || ''
		setBioText(bioStr)
		setUserIsVerified(true)

		const currentDob: string | undefined = userStateData.getDob()
		if (currentDob) {
			const dob: Date = new Date(currentDob)
			setDobDate(dob.getDate() < 10 ? `0${dob.getDate()}` : `${dob.getDate()}`)
			setDobMonth(dob.getMonth() + 1 < 10 ? `0${dob.getMonth() + 1}` : `${dob.getMonth() + 1}`)
			setDobYear(dob.getFullYear())
		}
	}

	// ================================================ DOB STUFF ===========================================
	const onDobDateChange = (newValue: string) => {
		// setDobDate(parseInt(newValue))
		setDobDate(newValue)
		setValuesUpdated(true)
	}
	const onDobMonthChange = (newValue: string) => {
		// setDobMonth(parseInt(newValue))
		setDobMonth(newValue)
		setValuesUpdated(true)
	}
	const onDobYearChange = (newValue: string) => {
		setDobYear(parseInt(newValue))
		setValuesUpdated(true)
	}

	const saveButtonClickHandler = () => {
		setValuesUpdated(false)
		setUpdatingUserData(true)
		userStateData.setAboutText(bioText)
		if (dobDate && dobMonth && dobYear) {
			userStateData.setDob(parseInt(dobDate), parseInt(dobMonth) - 1, dobYear)
		}
		updateConnector.updateUserDataRequest(userStateData.getId()).then((successRequest) => {
			setUpdatingUserData(false)
			if (!successRequest) {
				console.log('WARNING - [AppProfileSettings] - saveButtonClickHandler() failed')
			} else {
				updateCookies()
				window.location.replace(`${PAGE_URLS.APP_PROFILE_USER}?id=${userStateData.getId()}`)
				// window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
			}
			setUpdatingUserData(false)
		})
	}

	return (
		<>
			<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-profile-settings-full-section'>
				<div className='app-profile-settings-top-section-wrap'>
					<div className='app-profile-settings-top-section'>
						<div className='app-profile-settings-top-section-cover-image-wrap'>
							{heroImgSrc !== undefined &&
								<img
									className='app-profile-settings-top-section-cover-image-img'
									src={heroImgSrc}
									alt='Hero Img'
								/>
							}
							<div className='app-profile-settings-top-section-cover-image-overlay' />
							<label
								// className='dashboard-profile-profile-img-upload-button'
								className='app-profile-settings-switch-img'
							>
								<input
									className='app-profile-settings-hidden-input'
									type='file'
									onChange={(e) => {
										setUploadingProfilePic(false)
										onFileChange(e)
									}}
									accept='image/*'
									disabled={uploadingImage || updatingUserData}
								/>
								<img 
									className='app-profile-settings-switch-img'
									src='/imgs/icons/settings/icon-settings-switch-picture.svg'
									alt='Switch Hero Icon'
								/>
							</label>
							{/* <img 
								className='app-profile-settings-switch-img'
								src='/imgs/icons/settings/icon-settings-switch-picture.svg'
								alt='Switch Hero Icon'
							/> */}
							<a
								href={`${PAGE_URLS.APP_PROFILE_USER}?id=${userStateData.getId()}`}
								className='app-instructor-back-button'
							>
								<img
									src='/imgs/icons/shared/icon-instructor-shared-button.svg'
									alt='Back'
								/>
							</a>
						</div>
						<div
							className='app-profile-settings-img-wrap'
						>
							{userProfileIconUrl !== undefined &&
								<img 
									className='app-profile-settings-img'
									src={userProfileIconUrl}
									alt='Profile'
								/>
							}
							<div className='app-profile-settings-top-section-cover-image-overlay' />
							<label
								className='app-profile-settings-switch-img'
							>
								<input
									className='app-profile-settings-hidden-input'
									type='file'
									onChange={(e) => {
										setUploadingProfilePic(true)
										onFileChange(e)
									}}
									accept='image/*'
									disabled={uploadingImage || updatingUserData}
								/>
								<img 
									className='app-profile-settings-switch-img'
									src='/imgs/icons/settings/icon-settings-switch-picture.svg'
									alt='Switch Hero Icon'
								/>
							</label>
							{/* <img 
								className='app-profile-settings-switch-img'
								src='/imgs/icons/settings/icon-settings-switch-picture.svg'
								alt='Switch Profile Icon'
							/> */}
						</div>
						<button
							className='app-profile-settings-save-button'
							disabled={valuesUpdated === false}
							onClick={() => {
								// console.log('Save Changes')
								saveButtonClickHandler()
							}}
						>Save</button>
					</div>
				</div>
				{/* <div className='app-profile-settings-bio-section-wrap'>
					<div className='app-profile-settings-top-name-wrap'>
						<div className='app-profile-settings-top-name'>{usersName}</div>
						{userIsVerified && 
							<img
								className='app-profile-settings-verify-tick'
								src='/imgs/icons/profile/icon-profile-verified-tick.svg'
								alt='Verified tick'
							/>
						}
					</div>
					<div 
						className='app-profile-settings-bio-text'
					>
						{bioText.length > 1 ? 
							<>
								{bioExpanded ? bioText : `${bioText.substring(0, 20)} ... `}
								{bioExpanded === false && 
									<div 
										className='app-profile-settings-bio-show-more'
										onClick={() => {
											setBioExpanded(true)
										}}
									>see more</div>
								}
							</> :
							<>No Bio Provided</>
						}
					</div>
				</div> */}
				<div className='app-profile-settings-content-section-wrap'>
					<table className='app-profile-settings-content-section-table'>
						<tbody className='app-profile-settings-content-section-tbody'>
							<tr>
								<td>Username</td>
								<td>{usersName}</td>
							</tr>
							<tr>
								<td>Bio</td>
								<td>
									<textarea
										className='app-profile-settings-content-section-textarea'
										placeholder='Add your bio'
										value={bioText}
										onChange={(event) => {
											setBioText(event.target.value)
											setValuesUpdated(true)
										}}
									/>
								</td>
							</tr>
							{/* <tr>
								<td>Links</td>
								<td>
									<input
										className='app-profile-settings-td-input'
										value={links}
										placeholder='Add Links'
										onChange={(event) => {
											setValuesUpdated(true)
											setLinks(event.target.value)
										}}
									/>
								</td>
							</tr> */}
							<tr>
								<td>Gender</td>
								<td className='app-profile-settings-input-disabled'>
									<select
										className={`app-profile-settings-input-select ${gender == '' ? 'app-profile-settings-input-select-unset' : ''}`}
										value={gender ? gender : ''}
										// disabled={makingPost}
										onChange={(evt) => {
											genderSelectHandler(evt.target.value)
											setValuesUpdated(true)
										}}
									>
										<option value="" disabled>Gender</option>
										{INSTRUCTOR_GENDERS.map((valueLabel: string, index: number) => 
											<option 
												value={valueLabel}
												key={`genderOption${index}`}
											>{valueLabel}</option>
										)}
									</select>
								</td>
							</tr>
							<tr>
								<td>Birthday</td>
								<td className='app-profile-settings-input-disabled'>
									<select
										className={`app-profile-settings-input-select ${dobDate == '' ? 'app-profile-settings-input-select-unset' : ''}`}
										value={`${dobDate}`}
										// disabled={makingPost}
										onChange={(evt) => {
											// genderSelectHandler(evt.target.value)
											onDobDateChange(evt.target.value)
											// setValuesUpdated(true)
										}}
									>
										<option value="" disabled>??</option>
										{
											Array.from({ length: 31 }, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`).map((valueLabel: string, index: number) => 
												<option 
													value={valueLabel}
													key={`dobDate${index}`}
												>{valueLabel}</option>
											)
										}
									</select>
									/
									<select
										className={`app-profile-settings-input-select ${dobMonth == '' ? 'app-profile-settings-input-select-unset' : ''}`}
										value={dobMonth}
										// disabled={makingPost}
										onChange={(evt) => {
											// genderSelectHandler(evt.target.value)
											onDobMonthChange(evt.target.value)
											// setValuesUpdated(true)
										}}
									>
										<option value="" disabled>??</option>
										{
											Array.from({ length: 12 }, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`).map((valueLabel: string, index: number) => 
												<option 
													value={valueLabel}
													key={`dobMonth${index}`}
												>{valueLabel}</option>
											)
										}
									</select>
									/
									<select
										className={`app-profile-settings-input-select ${dobYear == undefined ? 'app-profile-settings-input-select-unset' : ''}`}
										value={dobYear ? `${dobYear}` : ''}
										// disabled={makingPost}
										onChange={(evt) => {
											// genderSelectHandler(evt.target.value)
											onDobYearChange(evt.target.value)
											// setValuesUpdated(true)
										}}
									>
										<option value="" disabled>????</option>
										{
											Array.from({ length: 50 }, (_, i) => `${i + 2025 - 15 - 50}`).map((valueLabel: string, index: number) => 
												<option 
													value={valueLabel}
													key={`dobYear${index}`}
												>{valueLabel}</option>
											)
										}
									</select>
								</td>
								{/* <td className='app-profile-settings-input-disabled'>??/??/????</td> */}
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<BackToTopButton />
			<AppFooter activeIndex={4} remainActive={true} />
			{imageSrc &&
				<div className='cropper-modal'>
					<div className='cropper-wrapper'>
						<Cropper
							image={imageSrc}
							crop={crop}
							rotation={rotation}
							zoom={zoom}
							aspect={uploadingProfilePic ? 1 : 2.5}
							cropShape={uploadingProfilePic ? 'round' : 'rect'}
							onCropChange={setCrop}
							onRotationChange={setRotation}
							onCropComplete={onCropComplete}
							onZoomChange={setZoom}
						/>
					</div>
					<div className='cropped-button-wrap'>
						<CtaButton
							label='Cancel'
							size='medium'
							onClick={() => {
								setImageSrc(null)
							}}
						/>
						<CtaButton
							label='Crop Image'
							size='medium'
							onClick={() => {
								showCroppedImage()
							}}
						/>
					</div>
				</div>
			}
		</>
	)
}

export default AppProfileSettings
